import { convertToTitleCase } from "utils/string.ts";
import { UnavailableDataPlaceholderText } from "constants/text.ts";

export const camelCaseToSpaced = (str: string): string =>
	str
		? convertToTitleCase(str.replaceAll(/(?<lowercase>[a-z])(?<uppercase>[A-Z])/g, "$<lowercase> $<uppercase>"))
		: UnavailableDataPlaceholderText;
